var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "msp-time-to-maintenance" }, [
    _c(
      "div",
      { staticClass: "msp-time-to-maintenance__title" },
      [
        _c("pui-headline", { attrs: { type: "h4" } }, [
          _vm._v(" " + _vm._s(_vm.$t("remainingLife")) + " "),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "msp-time-to-maintenance__radial" },
      [
        _c("div", {
          directives: [
            {
              name: "pui-tooltip",
              rawName: "v-pui-tooltip",
              value: {
                message:
                  _vm.activitiesTotal +
                  " " +
                  _vm.$t("activitiesTotal") +
                  (_vm.showToleranceExceeded || _vm.showWithinTolerance
                    ? ":"
                    : "") +
                  " \n " +
                  (_vm.showToleranceExceeded
                    ? (_vm.timeToMaintenanceData &&
                        _vm.timeToMaintenanceData
                          .numberOfMaintenancesToleranceExceeded) +
                      " - " +
                      _vm.$t("toleranceExceeded") +
                      " \n"
                    : "") +
                  " " +
                  (_vm.showWithinTolerance
                    ? (_vm.timeToMaintenanceData &&
                        _vm.timeToMaintenanceData
                          .numberOfMaintenancesWithinTolerance) +
                      " - " +
                      _vm.$t("withinTolerance")
                    : ""),
              },
              expression:
                "{\n                message:\n                    `${activitiesTotal} ${$t('activitiesTotal')}${showToleranceExceeded || showWithinTolerance ? ':' : ''} \\n ${\n                        showToleranceExceeded ? `${timeToMaintenanceData && timeToMaintenanceData.numberOfMaintenancesToleranceExceeded} - ${$t('toleranceExceeded')} \\n` : ''\n                    } ${\n                        showWithinTolerance ? `${timeToMaintenanceData && timeToMaintenanceData.numberOfMaintenancesWithinTolerance} - ${$t('withinTolerance')}` : ''\n                    }`\n            }",
            },
          ],
          staticClass: "msp-time-to-maintenance__tooltip-trigger",
        }),
        _c("echarts", { attrs: { option: _vm.timeToMaintenanceOption } }),
      ],
      1
    ),
    _c("div", { staticClass: "msp-time-to-maintenance__card-life-data" }, [
      _c(
        "div",
        { staticClass: "msp-time-to-maintenance__card-life-data__clearfix" },
        [
          _c(
            "strong",
            {
              staticClass:
                "msp-time-to-maintenance__card-life-data__clearfix__value",
            },
            [_vm._v(" " + _vm._s(_vm.activitiesTotal) + " ")]
          ),
          _c(
            "strong",
            {
              staticClass:
                "msp-time-to-maintenance__card-life-data__clearfix__lbl",
            },
            [_vm._v(" " + _vm._s(_vm.$t("activitiesTotal")) + ": ")]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "msp-time-to-maintenance__card-life-data__clearfix" },
        [
          _c(
            "span",
            {
              staticClass:
                "msp-time-to-maintenance__card-life-data__clearfix__value",
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.timeToMaintenanceData
                      ? _vm.timeToMaintenanceData
                          .numberOfMaintenancesThresholdOne
                      : 0
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass:
                "msp-time-to-maintenance__card-life-data__clearfix__lbl",
            },
            [_vm._v(" 0-" + _vm._s(_vm.REMAINING_LIFE_LOWER_LIMIT) + "% ")]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "msp-time-to-maintenance__card-life-data__clearfix" },
        [
          _c(
            "span",
            {
              staticClass:
                "msp-time-to-maintenance__card-life-data__clearfix__value",
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.timeToMaintenanceData
                      ? _vm.timeToMaintenanceData
                          .numberOfMaintenancesThresholdTwo
                      : 0
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass:
                "msp-time-to-maintenance__card-life-data__clearfix__lbl",
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.REMAINING_LIFE_LOWER_LIMIT) +
                  "-" +
                  _vm._s(_vm.REMAINING_LIFE_UPPER_LIMIT) +
                  "% "
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "msp-time-to-maintenance__card-life-data__clearfix" },
        [
          _c(
            "span",
            {
              staticClass:
                "msp-time-to-maintenance__card-life-data__clearfix__value",
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.timeToMaintenanceData
                      ? _vm.timeToMaintenanceData
                          .numberOfMaintenancesThresholdThree
                      : 0
                  ) +
                  " "
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass:
                "msp-time-to-maintenance__card-life-data__clearfix__lbl",
            },
            [_vm._v(" " + _vm._s(_vm.REMAINING_LIFE_UPPER_LIMIT) + "-100% ")]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }